import { NgModule } from '@angular/core';
import { AngLibComponent } from './ang-lib.component';
import { CardComponent } from './components/card/card.component';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { UtilsService } from './services/utils.service';

@NgModule({
  imports: [
    HttpClientModule,
    CommonModule
  ],
  declarations: [AngLibComponent, CardComponent],
  providers: [UtilsService],
  exports: [AngLibComponent, CardComponent]
})
export class AngLibModule {

}
